<script>
  import { Dropdown } from 'element-ui'
  export default {
    name:'ElDropdown',
    extends:Dropdown
  }
</script>
